import { render, staticRenderFns } from "./shixun-qa.vue?vue&type=template&id=2097c94c&scoped=true&"
import script from "./shixun-qa.vue?vue&type=script&lang=ts&"
export * from "./shixun-qa.vue?vue&type=script&lang=ts&"
import style0 from "./shixun-qa.vue?vue&type=style&index=0&id=2097c94c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2097c94c",
  null
  
)

export default component.exports